module.exports = __webpack_public_path__ + "static/media/kokansetsuSoto.6a2e43b2.png";